<template>
  <div class="myTbale">
    <el-table
      id="myTable"
      ref="table"
      :max-height="tableHeight"
      :data="dataSource1"
      :fit="fit"
      :stripe="stripe"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      v-loading="loading"
      @selection-change="handleSelectionChange">
      <!-- 是否支持选择 -->
      <el-table-column
        v-if="hasSelection"
        type="selection"
        width="80px"
        align="center"
        >
      </el-table-column>
      <!-- 是否显示序号 -->
      <el-table-column
        v-if="hasIndex"
        type="index"
        width="80px"
        align="center"
        >
      </el-table-column>

      <template v-for="(column, index) in columns" :key='column.label'>
        <el-table-column
            :prop="column.prop"
            :label="column.label"
            :align="column.align"
            :width="column.width"
            :type="column.expand"
            :show-overflow-tooltip='column.tooltip'>
          <template #default="scope">
            <!-- render的优先级高于formatter, formatter实过滤数据, render实生成新的组件 -->
            <template v-if="!column.render">
              <template v-if="column.formatter">
                <span v-html="column.formatter(scope.row, column)"></span>
              </template>
              <template v-else-if="column.pop">
                <template v-if="column.pop == 'user_id_num'" >
                  <a style="color:rgba(22, 93, 255, 1)" :href="'https://facebook.com/' + scope.row['user_id']" target="_blank">Jump page</a>
                </template>
                <template v-else>
                  <el-popover effect="light" trigger="hover" placement="top" width="auto">
                    <template #default>
                      <div>{{ scope.row[column.pop]}}</div>
                    </template>
                    <template #reference>
                      <span>{{scope.row[column.pop] ? scope.row[column.pop].length > 9 ? scope.row[column.pop].substring(0,10)+ '...' : scope.row[column.pop].substring(0,10) : ''}}</span>
                    </template>
                  </el-popover>
                </template>
                
              </template>
              <template v-else>
                <!-- <span></span> -->
                <div style="width:100%;">{{scope.row[column.prop]}}</div>
              </template>
            </template>
            <template v-else>
              <expand-dom :column="column" :row="scope.row" :render="column.render" :index="index"></expand-dom>
            </template>
          </template>
        </el-table-column>
      </template>

      <!-- 操作 -->
      <slot name="handleColumn">
      </slot>
    </el-table>
  </div>
</template>
<script>
// import { prop } from 'dom7';

import { onMounted, onUpdated, ref, watchEffect,nextTick } from 'vue'
// import { defineProps } from 'vue'
export default {
  
  props: ['loading','columns', 'msg', 'hasSelection', 'hasIndex', 'columns', 'dataSource', 'stripe', 'fit', 'headerCellStyle', 'cellStyle', 'computeHeight'],
  components: {
    expandDom: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null
        }
      },
      render: (h, ctx) => {
        console.log(4444,h.column)
        console.log(555,ctx.props)
        const params = {
          row: h.row,
          index: h.index
        }
        if (h.column) params.column = h.column
        return ctx.props.render(h, params)
      }
    }
  },
  setup(props,{emit}) {
    const selectionArr = ref([]) // 选中的数据
    const tableHeight = ref(0) // 高度
    const dataSource1 = ref([])
    console.log(1,props)
    console.log(2,props)
    onMounted (() => {
      console.log(5,window.innerHeight,props.computeHeight)
      nextTick(() => {
        // tableHeight.value = window.innerHeight - props.computeHeight
        tableHeight.value = props.computeHeight
        // this.tableHeight = (window.innerHeight - this.computeHeight) > 300 ? 'window.innerHeight - this.computeHeight' : 300
        // 后面的50：根据需求空出的高度，自行调整
        // console.log(555,this.columns)
        // console.log(666, props.dataSource)
        // console.log(dataSource1.value)
        
      })
    })
    watchEffect(() => {
      console.log(4444,props.computeHeight)
      tableHeight.value = props.computeHeight
      dataSource1.value = props.dataSource
    })
    // 将选中的行发送到父组件
    const handleSelectionChange = val => {
      console.log(444,val)
      const selectionArr = ref([])
      // val.forEach((item) => {
      //     selectionArr.value.push(item.)
      // })
      emit('commitSelection', val)
    }
    onUpdated (() => {
      console.log(333)
      // tableHeight.value = window.innerHeight - props.computeHeight
      tableHeight.value = props.computeHeight
    })
    return {
      selectionArr,
      handleSelectionChange,
      dataSource1, // 表格信息
      tableHeight
    }
  }
}

// console.log(8, columns)
// console.log(9, msg)
// export default {
//   name: 'myTable',
//   data () {
//     return {
//       tableHeight: 0
//     }
//   },
  // props: {
    // 相应字段的展示
    // 是否为斑马纹
    // 是否自动撑开列宽
    // 头部样式
    // 每行的样式
  // components: {
  //   expandDom: {
  //     functional: true,
  //     props: {
  //       row: Object,
  //       render: Function,
  //       index: Number,
  //       column: {
  //         type: Object,
  //         default: null
  //       }
  //     },
  //     render: (h, ctx) => {
  //       const params = {
  //         row: ctx.props.row,
  //         index: ctx.props.index
  //       }
  //       if (ctx.props.column) params.column = ctx.props.column
  //       return ctx.props.render(h, params)
  //     }
  //   }
  // },
  // methods: {
  // updated () {
  //   this.$nextTick(() => {
  //     this.tableHeight = (window.innerHeight - this.computeHeight)
  //     // this.tableHeight = (window.innerHeight - this.computeHeight) > 300 ? 'window.innerHeight - this.computeHeight' : 300
  //     // 后面的50：根据需求空出的高度，自行调整
  //   })
  // }
// }
</script>

<style lang="scss">
.el-pagination__sizes{
  display: none!important;
}
.el-pagination__jump{
  display: none!important;
}
.icon-group{
  i{
    font-style: normal;
    // padding: 0 5px;
    margin-right:12px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #165DFF;
  }
}
</style>
<style lang="scss">
.myTbale{
  .el-table .cell{
    padding-left:0;
  }
  .el-table td.el-table-fixed-column--right .cell{
    padding-left:20px;
  }
  
  .el-table th.el-table-fixed-column--right{
    .cell{
    //  display:block;
     padding-left:20px;
    }
  }
  // overflow-y: visible;
  .el-table__body tr:hover{
    .operation{
      display: block
    }
  }
  .operation{
    display: none;
    cursor: pointer;
    -webkit-user-select:none;/*谷歌 /Chrome*/
    -moz-user-select:none; /*火狐/Firefox*/
    -ms-user-select:none;    /*IE 10+*/
    user-select:none;
  }
  .el-table--enable-row-transition .el-table__body tr.hover-row,
  .el-table--enable-row-transition .el-table__body tr.hover-row>td{
    background:rgba(239,245,248,1)!important;
     .operation{
      display: block
    }
  };
  .el-icon.el-icon-arrow-right{
    display: none
  };
  .el-table td:nth-of-type(1),.el-table th:nth-of-type(1){
    padding-left: 30px!important;
  }
  .el-table thead tr th{
    background: #F2F3F5!important;
  }
  .el-table:not(.el-table--border) td{
    border-bottom: 1px solid #E5E6EB;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner{
    background:#165DFF;
  }
}

</style>
